'use client';

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel';
import type {
  MarketingLandingCopy,
  MarketingRolePageCopy,
} from '@/i18n/marketing-landing-copy';
import { MarketingSquare } from '@/components/marketing-landing/section-label';
import { SectionShell } from '@/components/marketing-landing/section-shell';

export function RoleTestimonials({
  testimonials,
  controls,
  direction,
}: {
  testimonials: MarketingRolePageCopy['testimonials'];
  controls: MarketingLandingCopy['showcaseControls'];
  direction: 'ltr' | 'rtl';
}) {
  return (
    <section
      className="bg-marketing-mist py-56 md:py-80 lg:py-40"
      aria-labelledby="role-testimonials-heading"
    >
      <SectionShell>
        <div className="text-center">
          <p className="text-sm font-medium md:text-[clamp(0.875rem,1.25vw,1.5rem)]">
            {testimonials.eyebrow}
          </p>
          <h2
            id="role-testimonials-heading"
            className="mt-3 text-[clamp(1.5rem,3.4vw,4rem)] leading-tight font-semibold"
          >
            {testimonials.heading}
          </h2>
        </div>
        <Carousel
          opts={{ align: 'start', direction }}
          aria-labelledby="role-testimonials-heading"
          className="mt-16 lg:mx-auto lg:max-w-[84%]"
        >
          <CarouselContent className="-ml-2 md:-ml-4">
            {testimonials.quotes.map((quote) => (
              <CarouselItem
                key={quote.attribution}
                className="basis-[85%] pl-2 md:basis-1/3 md:pl-4"
              >
                <figure className="border-marketing-fg flex aspect-square h-full flex-col rounded-2xl border p-4 md:aspect-5/4 md:p-[clamp(1rem,1.25vw,1.5rem)]">
                  <MarketingSquare className="mb-4" />
                  <blockquote className="text-sm leading-snug font-medium md:text-[clamp(0.75rem,1.25vw,1.5rem)]">
                    {quote.body}
                  </blockquote>
                  <figcaption className="mt-auto pt-10 text-xs leading-snug md:text-[clamp(0.625rem,0.85vw,1rem)]">
                    {quote.attribution}
                  </figcaption>
                </figure>
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="mt-16 hidden justify-center gap-2 md:flex">
            <CarouselPrevious
              aria-label={controls.previous}
              className="bg-marketing-cta text-marketing-cta-fg hover:bg-marketing-panel hover:text-marketing-panel-fg static size-14 translate-y-0 rounded border-0 disabled:opacity-100"
            />
            <CarouselNext
              aria-label={controls.next}
              className="bg-marketing-cta text-marketing-cta-fg hover:bg-marketing-panel hover:text-marketing-panel-fg static size-14 translate-y-0 rounded border-0 disabled:opacity-100"
            />
          </div>
        </Carousel>
      </SectionShell>
    </section>
  );
}
